import { useQuery } from '@apollo/client';
import { Link } from '@apollo/orbit';
import React from 'react';

import { parseGraphRef } from 'src/app/graph/hooks/useGraphRef';
import { variantHomepageRouteConfig } from 'src/app/graph/routes';
import { AlertWithCTA } from 'src/app/graph/variantsHomepage/components/AlertWithCTA';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { getRouterIds } from './helpers';
import { graphsWithFlyProviderQuery } from './query';

export const MigrationAlertBanner = ({ accountId }: { accountId: string }) => {
  const { data } = useQuery<
    GraphQLTypes.GraphsWithFlyProviderQuery,
    GraphQLTypes.GraphsWithFlyProviderQueryVariables
  >(graphsWithFlyProviderQuery, {
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
    variables: {
      accountId,
    },
  });

  const routerIds = getRouterIds(data);

  const formattedRouterIds = routerIds.map((id, index) => {
    const graphRef = parseGraphRef(id);

    if (!graphRef) {
      return null;
    } else {
      return (
        <span key={id}>
          <Link to={variantHomepageRouteConfig.path({ ...graphRef })}>
            {id}
          </Link>
          {index < routerIds.length - 2 ? (
            ', '
          ) : index === routerIds.length - 2 ? (
            <span className="mx-1">and</span>
          ) : (
            ''
          )}
        </span>
      );
    }
  });

  const isSingular = formattedRouterIds.length === 1;

  return (
    <>
      {formattedRouterIds.length > 0 && (
        <AlertWithCTA
          status="warning"
          id="alert-router-migration"
          message={
            <>
              Migration required: your variant{isSingular ? ' ' : 's '}
              {formattedRouterIds} {isSingular ? 'is' : 'are'} scheduled for
              deletion on June 27, 2024.
            </>
          }
          maybeCTA={{
            href: 'https://www.apollographql.com/docs/graphos/cloud-routing/serverless/aws-migration/',
            text: 'Learn more',
          }}
        />
      )}
    </>
  );
};
